/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import { renderHTML } from '../../lib/helpers'

import { Cont, FlexCols, FlexCol, VStack } from '../../styles/els'

import AboutDiagram from './blocks/about-diagram'
import Benefits from './blocks/benefits'
import Cards from './blocks/cards'
import Detail from './blocks/detail'
import Hubspot from './blocks/hubspot'
import PricingDiagram from './blocks/pricing-diagram'
import PricingTable from './blocks/pricing-table'
import Text from './blocks/text'
import Videos from './blocks/videos'
import VideoText from './blocks/video-text'
import TextIcons from './blocks/text-icons'

const map = {
  WpPage_Acftemplatepage_PageBlocks_AboutImage: AboutDiagram,
  WpPage_Acftemplatepage_PageBlocks_Benefits: Benefits,
  WpPage_Acftemplatepage_PageBlocks_Cards: Cards,
  WpPage_Acftemplatepage_PageBlocks_Detail: Detail,
  WpPage_Acftemplatepage_PageBlocks_Hubspot: Hubspot,
  WpPage_Acftemplatepage_PageBlocks_PricingDiagram: PricingDiagram,
  WpPage_Acftemplatepage_PageBlocks_PricingTable: PricingTable,
  WpPage_Acftemplatepage_PageBlocks_Text: Text,
  WpPage_Acftemplatepage_PageBlocks_Videos: Videos,
  WpPage_Acftemplatepage_PageBlocks_VideoText: VideoText,
  WpPage_Acftemplatepage_PageBlocks_TextIcons: TextIcons,
}

const PageBlocks = (props) => {
  const { blocks, ...otherProps } = props

  return blocks && blocks.length > 0 ? (
    <section>
      <Cont>
        <VStack space={[4, 7]}>
          {blocks.map((_block, _i) => {
            const _type = _block.__typename
            const Component = map[_type]
            return Component ? <Component key={_i} {..._block} /> : null
          })}
        </VStack>
      </Cont>
    </section>
  ) : null
}

export default PageBlocks
